import './global';

/* features */
import '../features/backInStock/scripts';
import '../features/cartRecommendations/scripts';
import '../features/outOfStockDrawer/scripts';
import '../features/productGalleryCounter/scripts';
import '../features/productUpsell/scripts';
import '../features/storesList/scripts';
// import '../features/twoLayerNavigation/scripts';
import '../features/wishlistPage/scripts';
import '../features/notifyMe/scripts';
import '../features/comingSoon/scripts';

import '../features/clubPromoBlock/scripts';
import '../features/freeGift';
import '../features/giftBox/scripts';
import '../features/personalData/scripts';
import '../features/productEmbroidery/scripts';
import '../features/registrationForm/scripts';
import '../features/wishlistBlock/scripts';
import '../features/collectionGridSizeDisplay/scripts';
import '../features/embroideryDrawer/scripts';
import '../features/giftGuide/scripts';
import '../features/header/scripts';
import '../features/customContent/scripts';
